var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"fill":"none","height":"24","width":"24"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"}))]);
}

Download.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"};

module.exports = Download;

Download.default = Download;
